export enum SchoolTypeEnum  {
  KINDER_GARDEN=1,
  PRIVATE_SCHOOL=2,
  PUBLIC_SCHOOL=3,
}
